import { useField, useFormikContext } from 'formik';
import { createContext, useContext } from 'react';

import { CustomerTypeOption } from '../quotes/view-or-edit-bill-of-materials/dataForViewOrEditQuoteBillOfMaterialsForm';

export type BillOfMaterialsContextValue = {
  isUsingLegacyPricingModel: boolean;
  customerTypeOptions: Array<CustomerTypeOption>;
};

export const BillOfMaterialsContext = createContext<BillOfMaterialsContextValue>({
  isUsingLegacyPricingModel: false,
  customerTypeOptions: [],
});

export const useBillOfMaterialsPricingModelInfo = () => {
  const { isUsingLegacyPricingModel, customerTypeOptions } = useContext(BillOfMaterialsContext);

  const hasFormikContext = !!useFormikContext();

  if (!hasFormikContext) {
    throw new Error(`${useBillOfMaterialsPricingModelInfo.name} must be used within a Formik form`);
  }

  const selectedCustomerTypeId = useField('customerTypeId')[0].value as number;

  const selectedCustomerTypeOption = customerTypeOptions.find(option => option.id === selectedCustomerTypeId);

  return { isUsingLegacyPricingModel, selectedCustomerTypeOption };
};
